// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import MaterialsTable from './materials-table';
// assets
//

// ----------------------------------------------------------------------

export default function TechnicalMaterials() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <MaterialsTable />
        </Container >
    );
}
